import '@pepsico-ds/ui/css'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'

if (import.meta.env.DEV) {
  const market = import.meta.env.VITE_COUNTRIES;
  if (market) {
    sessionStorage.setItem('countryCode', market);
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
